import { render } from "./AppTextEditor.vue?vue&type=template&id=6029ad05&scoped=true"
import script from "./AppTextEditor.vue?vue&type=script&lang=js"
export * from "./AppTextEditor.vue?vue&type=script&lang=js"

import "./AppTextEditor.vue?vue&type=style&index=0&id=6029ad05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6029ad05"]])

export default __exports__